// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChatV2 layout overrides for legacy ChatBar / ChatMessageComponent */

.chatv2-list-column .ChatBar-Main-Container {
  width: 100% !important;
  max-width: 100% !important;
  height: 100% !important;
  border: none !important;
  box-shadow: none !important;
  margin: 0 !important;
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chatv2-list-column .ChatBar-Container01 {
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chatv2-list-column .Chatbar-Heading,
.chatv2-list-column .ChatBar-Heading-Container {
  display: none !important;
}

.chatv2-list-column .ChatUser-Main-Container,
.chatv2-list-column .ArchiveUser-Main-Container,
.chatv2-list-column .UnAssigned-Main-Container {
  width: 100% !important;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.chatv2-thread .ChatMessage-Main-Container,
.chatv2-thread .ChatMessage-Container {
  width: 100% !important;
  max-width: 100% !important;
  flex: 1;
  min-height: 0;
  border: none !important;
  margin: 0 !important;
}

.chatv2-thread .ChatHeader-Main-Container {
  display: none !important;
}

.chatv2-page {
  height: calc(100vh - 0px);
  width: 100%;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  background: #fff;
  font-family: Inter, sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/ChatV2/chatV2Overrides.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;EAGE,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC","sourcesContent":["/* ChatV2 layout overrides for legacy ChatBar / ChatMessageComponent */\n\n.chatv2-list-column .ChatBar-Main-Container {\n  width: 100% !important;\n  max-width: 100% !important;\n  height: 100% !important;\n  border: none !important;\n  box-shadow: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.chatv2-list-column .ChatBar-Container01 {\n  width: 100% !important;\n  height: 100% !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.chatv2-list-column .Chatbar-Heading,\n.chatv2-list-column .ChatBar-Heading-Container {\n  display: none !important;\n}\n\n.chatv2-list-column .ChatUser-Main-Container,\n.chatv2-list-column .ArchiveUser-Main-Container,\n.chatv2-list-column .UnAssigned-Main-Container {\n  width: 100% !important;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.chatv2-thread .ChatMessage-Main-Container,\n.chatv2-thread .ChatMessage-Container {\n  width: 100% !important;\n  max-width: 100% !important;\n  flex: 1;\n  min-height: 0;\n  border: none !important;\n  margin: 0 !important;\n}\n\n.chatv2-thread .ChatHeader-Main-Container {\n  display: none !important;\n}\n\n.chatv2-page {\n  height: calc(100vh - 0px);\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n  background: #fff;\n  font-family: Inter, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
